import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Tab, Tabs, TextField } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import { Button } from "../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Input from "../../../../../stories/Input/Input";
import ItemGroupSelect from "../../../../../customComponents/ItemGroupSelect";
import ItemCategorySelect from "../../../../../customComponents/ItemCategorySelect";
import UoMSelect from "../../../../../customComponents/UoMSelect";
import { filterDataType } from "../../masters/items/queries/types";
import {
  CustomModal,
  handleMUISelectEvent
} from "../../../../../utils/UtilFunctions";
import {
  labelClasses,
  LabeledAutocomplete
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import LeftArrow from "../../../../../images/ArrowRight.svg";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import StockBalanceAdd from "../../purchase/stockbalance/StockBalanceAdd";
import { PageFor } from "../../../../../utils/Enum.types";
import StockDetails from "./StockDetails";
import useLabels from "../../../../../customHooks/useLabels";


interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const Data = [
  {
    name: "Shivaji Nagar",
    total: 0
  }
];
const ViewCompleteDetails = ({ setModalFlag}: Props) => {
  const [value, setValue] = useState(0);
  const [stockDetails, setStockDetails] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [filterData, setFilterData] = useState<filterDataType>({
    ItemGroupId: 0,
    ItemCategoryId: 0,
    UoMId: 0
  });
  const [searchData, setSearchData] = useState("");

  const { Maps } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] = Maps.CompanyDetails.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <button
                className="maps-comp-details__view"
                onClick={() => setStockDetails(!stockDetails)}
              >
                View Details
                <img src={EyeWhite} alt="" />
              </button>
            </>
          );
        }

        return params.value;
      }
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];
  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        subsidiary_name: data.name,
        total: data.total
      };
    }) || [];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MAPS_COMPANY_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MAPS_COMPANY_DETAILS,
      JSON.stringify(newModel)
    );
  };
  const {companyLabel,subsidiaryLabel,itemLabel}=useLabels();
  return (
    <div className="maps-comp-details">
          <div className="maps-comp-details__title">
        <Title>{companyLabel}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="maps-comp-details__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab label={`${subsidiaryLabel} Wise`} value={0} {...a11yProps(0)} />

          <Tab label={`${itemLabel} Wise`} value={1} {...a11yProps(1)} />
        </Tabs>
      </div>

      <div className="maps-comp-details__tab-panel">
        <TabPanel value={value} index={0}>
        
            <>
              <div className="maps-comp-details__tab-panel--top">
                <button>
                  <img src={LeftArrow} alt="" />
                  Back
                </button>
                <span>{subsidiaryLabel} Name</span>
              </div>
            </>
          

          <div className="maps-comp-details__tab-panel--select row g-0">
            <div className="col-2">
              <Input
                id="data_search"
                placeholder="Search..."
                onChange={(e) => {
                  setSearchData(e.target.value);
                }}
              />
            </div>
            <div className="col">
              <ItemGroupSelect
                onChange={(newValue) => {
                  if (newValue) {
                    setFilterData({
                      ...filterData,
                      ItemGroupId: newValue.value
                    });
                  } else {
                    setFilterData({
                      ...filterData,
                      ItemGroupId: 0
                    });
                  }
                }}
                value={filterData.ItemGroupId}
                onKeyDown={handleMUISelectEvent}
                label={`${itemLabel} Group`}
              />
            </div>
            <div className="col">
              <ItemCategorySelect
                onChange={(newValue) => {
                  if (newValue) {
                    setFilterData({
                      ...filterData,
                      ItemCategoryId: newValue.value
                    });
                  } else {
                    setFilterData({
                      ...filterData,
                      ItemCategoryId: 0
                    });
                  }
                }}
                value={filterData.ItemCategoryId}
                label={`${itemLabel} Category`}
                onKeyDown={handleMUISelectEvent}
              />
            </div>
            <div className="col">
              <UoMSelect
                onChange={(newValue) => {
                  if (newValue) {
                    setFilterData({
                      ...filterData,
                      UoMId: newValue.value
                    });
                  } else {
                    setFilterData({
                      ...filterData,
                      UoMId: 0
                    });
                  }
                }}
                value={filterData.UoMId}
                label="Unit of Measurement"
                onKeyDown={handleMUISelectEvent}
              />
            </div>
            <div className="col">
              <LabeledAutocomplete
                className={labelClasses.inputRoot}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                options={["a", "b"]}
                openOnFocus
                forcePopupIcon
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={labelClasses.formControlRoot}
                    label="Sub Category"
                    slotProps={{
                      inputLabel: {
                        shrink: true
                      }
                    }}
                  />
                )}
              />
            </div>
            <div className="col">
              <LabeledAutocomplete
                className={labelClasses.inputRoot}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                options={["a", "b"]}
                openOnFocus
                forcePopupIcon
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={labelClasses.formControlRoot}
                    label="Sub Category"
                    slotProps={{
                      inputLabel: {
                        shrink: true
                      }
                    }}
                  />
                )}
              />
            </div>
            <div className="col">
              <LabeledAutocomplete
                className={labelClasses.inputRoot}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                options={["a", "b"]}
                openOnFocus
                forcePopupIcon
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={labelClasses.formControlRoot}
                    label="Manufacturer"
                    slotProps={{
                      inputLabel: {
                        shrink: true
                      }
                    }}
                  />
                )}
              />
            </div>
          </div>
          <div className="maps-comp-details__tableblock--complete">
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel
                }
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          </div>
        </TabPanel>

        <TabPanel value={value} index={1}></TabPanel>
      </div>
     
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      

      <CustomModal
        style={ViewModalStyles}
        isOpen={stockDetails}
        onRequestClose={() => setStockDetails(!stockDetails)}
        contentComponent={<StockDetails setModalFlag={setStockDetails} />}
      />
    </div>
  );
};

export default ViewCompleteDetails;
